import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { initialize } from '@americanexpress/script-supplier';
import { CONSTANTS } from '../constants';

// Biocatch is loaded onto the page for fraud evaluation
    const domain = window.location.hostname;
    const getENV = () => {
        if (domain.toLowerCase() === CONSTANTS.prodUrl.lmsProd.toLowerCase() || domain.toLowerCase() === CONSTANTS.prodUrl.mediaCampProd.toLowerCase()) {
            return 'e3'
        }
        else if (domain.toLowerCase() === CONSTANTS.qaUrl.lmsQA.toLowerCase()) {
            return 'e2';
        }
        else
            return 'e1';
    }


let inauthid = null;
let biocatchid = null;


    const onLoadInAuth = () => {
        if (window.inauthSetTid !== undefined && window.cdApi !== undefined) {
            const iauuid = uuidv4();
            window.inauthSetTid(iauuid, 'GAC');
            inauthid = iauuid;
            // clientName = GAC
            // actSetInAuthUUID(uuid);
        }
    };

    const onLoadBiocatch = () => {
        if (window.cdApi !== undefined && window.inauthSetTid !== undefined) {
            const bcuuid = uuidv4().replace(/-/g, '');
            window.setPageContext('AboutYou');
            window.cdApi.setCustomerSessionId(bcuuid);
            biocatchid = bcuuid;
        }
    }

const InitializeBiocatchInauth = () => {
    let bioCatchAndInAuthID = [];
    const scripts = [
        {
            name: 'biocatch',
            windowCheck: 'cdApi',
            version: '^2.23.1',
            onload: onLoadBiocatch(),
            async: true
        },
        {
            name: 'inauth',
            windowCheck: 'inauthSetTid',
            version: '^1.1.0',
            onload: onLoadInAuth(),
            async: true
        }
    ];

    const scriptEnvironment = getENV();
    // `someMeansOfDeterminingThePageLocale` must be replaced with a function that you write that
    // correctly determines the locale of the page and returns it in a format like `'en-GB'` or
    // `'GB_en'`.

    const pageLocale = 'en-IN';

        initialize({
        scripts,
        scriptEnvironment,
        pageLocale
        });

    if (biocatchid !== null && inauthid !== null) {
        bioCatchAndInAuthID.push(biocatchid);
        bioCatchAndInAuthID.push(inauthid);
    }
    return bioCatchAndInAuthID;
};

export default InitializeBiocatchInauth;